import { useQuery } from '@tanstack/react-query'
import { queryClient } from '@/lib/react-query'
import { useAuthStore } from '@/store/useAuthStore'
import { useApiReady } from '@/hooks/useApiReady'

/**
 * Rôle dans l'équipe active — seed GET /auth/session uniquement.
 */
export function useTeamRole(teamId: string | null | undefined) {
  const { user, globalRole, activeTeamRole } = useAuthStore()
  const apiReady = useApiReady()
  const isFreelancer = globalRole === 'freelancer' || user?.role === 'freelancer'
  const seeded =
    user?.id && teamId
      ? queryClient.getQueryData<string | null>(['teamRole', user.id, teamId])
      : undefined

  return useQuery({
    queryKey: ['teamRole', user?.id, teamId],
    queryFn: async () => {
      if (!user || !teamId) return null

      if (isFreelancer) {
        return user.role || globalRole || 'freelancer'
      }

      if (teamId === useAuthStore.getState().activeTeamId && activeTeamRole) {
        return activeTeamRole
      }

      return user?.role || globalRole || null
    },
    enabled: apiReady && !!user && !!teamId && seeded === undefined,
    initialData: seeded,
    initialDataUpdatedAt: seeded !== undefined ? Date.now() : undefined,
    refetchOnMount: seeded !== undefined ? false : true,
    staleTime: 1000 * 60 * 10,
    retry: 1,
  })
}
